import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import your images
import Image3 from '../components/images/banners/ban_13.png'
import Image1 from '../components/images/banners/ban2.png'
import Image2 from '../components/images/banners/banner-esl.png'
import Image4 from '../components/images/banners/ban1.png'
import Image5 from '../components/images/banners/ban3.png'

function Slide() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
        cssEase: 'linear',
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                },
            },
        ],
    };

    const bannerImages = [
         Image4, Image1, Image2, Image5
    ];

    return (
        <div className="mx-auto w-full max-w-full overflow-hidden pt-5 mt-10" > {/* banner-slider */}
            <Slider {...settings}>
                {bannerImages.map((image, index) => (
                    <div key={index} className="flex items-center justify-center"> {/* slick-slide */}
                        <img
                            src={image}
                            alt={`Banner ${index + 1}`}
                            className="w-full h-full object-cover"
                            // style={{ 
                            //     width: '100%', 
                            //     height: 'auto', 
                            //     display: 'block',
                            //     verticalAlign: 'bottom' 
                            // }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default Slide;